
import React from 'react';
import { FormControl, FormHelperText, InputBaseProps, InputLabel } from '@material-ui/core';
import { Input } from '../../../ui-kit/TextField/TextField';
import { validateMaxDecimals } from '../../../utils';
import { TextFieldProps, TooltipedInfoIcon } from '../../../ui-kit';
import Field, { FieldProps } from './Field';

interface NumericInputProps extends Omit<TextFieldProps, 'onChange'> {
    onChange?: InputBaseProps['onChange'];
    maxDecimals?: number;
}

type NumericInputFieldProps<V> = Omit<FieldProps<V>, 'renderer'> & Omit<InputBaseProps, 'onChange'>;

const NumericInput = React.forwardRef(({
    label, id, className, required, helpertext, margin, tooltip, error, onChange, maxDecimals = 3, ...other
}: NumericInputProps , forwardRef) => {

    const textFieldLabel = label && (
        <InputLabel style={{ marginLeft: '6px' }} shrink htmlFor={id} error={!!error}>
            {label}
            {tooltip && (
                <TooltipedInfoIcon tooltip={tooltip} tooltipFontSize='1rem' />
            )}
        </InputLabel>
    );

    const handleChange: InputBaseProps['onChange'] = e => {
        const { value } = e.target;
        if (onChange){
            const validatedValue = validateMaxDecimals({ value: parseFloat(value), maxDecimals });
            e.target.value = validatedValue.toString();
            onChange(e);
        }
    };

    return (
        <FormControl fullWidth className={className} margin={margin || 'normal'} required={required}>
            {textFieldLabel}
            <Input
                onChange={handleChange}
                type='number'
                {...other}
                ref={forwardRef}
                id={id}
            />
            <FormHelperText error={!!error}>{helpertext}</FormHelperText>
        </FormControl>
    );
});

const NumericInputField = <V, >(props: NumericInputFieldProps<V>) => {
    return (
        <Field
            renderer={NumericInput}
            {...props}
        />
    );
};

export default NumericInputField;
